<template>
    <v-card class="kim-card pa-2">
        <template v-if="anamnesis !== null">


            <v-card-text class="text-left">
                <h1 class="body-2">Motivo de Consulta</h1>
                <v-textarea
                        lines="3"
                        @blur="save"
                        :loading="loadingSave"
                        :readonly="readonly"
                        filled
                        v-model="comment"
                        :error-messages="errorMessages"
                        :value="anamnesis.comment"
                        placeholder="Escribe algo..."></v-textarea>

            </v-card-text>

            <v-divider></v-divider>

            <v-card-text class="text-left pb-0" >
                <h1 class="body-2">Síntomas</h1>

                <v-layout wrap align-center v-if="!readonly">
                    <v-flex xs12 pa-1>
                        <symptom-picker
                                ref="symptomPicker"
                                label="Buscar síntoma"
                                :event-id="eventId"
                                @change="onSymptomSelect"
                        />
                    </v-flex>
                </v-layout>
            </v-card-text>

            <v-card-text class="pt-0">

              <v-simple-table dense>
                <template v-slot:default>
                  <thead>
                  <tr>
                    <th scope="col" class="text-left">Síntoma</th>
                    <th scope="col" class="text-left">Duración</th>
                    <th v-if="userIsOphthalmologist" scope="col" class="text-center">Ojo</th>
                    <th scope="col" class="text-center">Eliminar</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr
                      v-for="(item) in symptoms"
                      :key="item.pivot.id">
                    <td class="text-left">{{item.description}}</td>
                    <td class="text-left">
                      {{ item.pivot.duration ? `${item.pivot.duration} ${getDurationUnit(item.pivot.duration_unit)}` : '-' }}
                    </td>
                    <td v-if="userIsOphthalmologist" class="text-center">
                      {{ getEye(item.pivot.eye)}}
                    </td>
                    <td class="text-center">
                      <v-btn icon ripple v-if="!readonly">
                        <v-icon v-if="!readonly" color="accent" @click="deleteItem(item)">delete</v-icon>
                      </v-btn>
                    </td>

                  </tr>

                  </tbody>
                </template>
              </v-simple-table>

            </v-card-text>

            <v-card-text v-if="false" class="pt-0 pb-2 text-right">
                <div class="caption" v-if="time">Modificado por última vez: {{time || 'consultando...'}}</div>
            </v-card-text>
        </template>
        <template v-else>
            <v-card-text class="text-center pa-3">
                <div class="caption">Aún no ha comenzado la atención</div>
            </v-card-text>
        </template>
        <symptom-form :event-id="eventId" ref="symptomForm" @attach="onSymptomAttach" />
        <kimsa-confirm
                ref="deleteOptionModal"
                title="Eliminar opción"
                content="¿Está seguro que desea eliminar esta opción?"
                :loading="loadingOptionDelete"
                :persistent="false"
                @confirm="deleteOptionConfirm"
                :close-on-confirm="false"
        ></kimsa-confirm>
        <kimsa-confirm
                ref="deleteModal"
                title="Eliminar antecedente"
                content="¿Está seguro que desea eliminar este item?"
                :loading="loadingDelete"
                :persistent="false"
                @confirm="deleteItemConfirm"
                :close-on-confirm="false"
        ></kimsa-confirm>
    </v-card>
</template>

<script>

    import {ApiUtils} from '@/utils/ApiUtils'
    import {debounce} from '@/utils/Common'

    import {mapState, mapMutations} from 'vuex'

    import {userProvides, OPHTHALMOLOGY} from '@/utils/Specialist'

    import SymptomPicker from './SymptomPicker.vue'
    import KimsaConfirm from '@/components/common/KimsaConfirm'
    import SymptomForm from './SymptomForm'

    export default{
        components: {
            SymptomPicker,
            SymptomForm,
            KimsaConfirm
        },
        props: ['eventId', 'anamnesis', 'readonly'],
        data(vm){
            return {

                loadingSave: false,
                loadingAttach: false,
                loadingDelete: false,
                loadingOptionDelete: false,

                paginationOptions: {
                    sortDesc: true,
                    page: 1,
                    itemsPerPage: -1, // -1 for All",
                    sortBy: ["pivot.id"],
                    totalItems: 1000
                },

                symptomToDetach: null,
                symptomToAttach : {
                    schedule_event_id: vm.eventId,
                    symptom_id: null,
                    eye: 'left',
                    duration: 0,
                    duration_unit: 'day'
                },

                symptoms: vm.anamnesis && vm.anamnesis.symptoms || [],
                optionToDetach: null,
                options: vm.anamnesis && vm.anamnesis.anamnesis_options || [],
                symptomHeaders: [
                    {
                        text: 'Síntoma',
                        align: 'left',
                        sortable: false,
                        value: 'pivot.description'
                    },
                    { text: 'Duración', value: 'pivot.duration',   align: 'center', sortable: true,},
                    { text: 'Unidad', value: 'pivot.duration_unit' ,   align: 'center',},
                    { text: 'Ojo', value: 'pivot.eye',   align: 'center', },
                    { text: 'Eliminar', value: 'iron' ,   align: 'center',}
                ],

                commentChanged: false,
                errorMessages: '',
                updatedAt:  vm.anamnesis && vm.anamnesis.updated_at || null,
                comment: vm.anamnesis && vm.anamnesis.comment || '',
                time: '',
                timeInterval: null
            }
        },
        mounted(){
            this.setTimeData()
        },
        beforeDestroy(){
            var vm = this
            clearInterval(vm.timeInterval)
        },
        computed: {
                ...mapState(['currentProvider']),
            userIsOphthalmologist(){
                return userProvides(OPHTHALMOLOGY)
            },
            durationUnits(){
                return [
                    {
                        text: 'año(s)',
                        value: 'year'
                    },
                    {
                        text: 'mes(es)',
                        value: 'month'
                    },
                    {
                        text: 'semana(s)',
                        value: 'week'
                    },
                     {
                        text: 'día(s)',
                        value: 'day'
                    },
                    {
                        text: 'hora(s)',
                        value: 'hour'
                    },
                   /* {
                        text: 'minuto(s)',
                        value: 'minute'
                    }*/
                ]
            }
        },
        methods: {
            ...mapMutations(['showSnackBar']),
            getEye(eye){
                switch(eye){
                    case 'left':
                        return 'izquierdo'
                    case 'right':
                        return 'derecho'
                    case 'both':
                        return 'ambos'
                    default:
                        return '-'
                }
            },
            async onOptionSelect(option){

                var vm = this
                if(!option) return

                vm.loadingAttach = true
                const response = await ApiUtils.makePost(`anamnesis/option/attach`, {
                    schedule_event_id: vm.eventId,
                    anamnesis_option_id: option.id
                })
                vm.loadingAttach = false

                if(response.ok){
                    const json = await response.json()
                    const attachedItem = json.result.anamnesis_option
                    vm.$emit('attach:option', attachedItem)
                }
            },
            deleteOption(option){
                var vm = this
                vm.optionToDetach = option
                vm.$refs.deleteOptionModal.show()
            },
            deleteItem(item){
                var vm = this
                vm.symptomToDetach = item
                vm.$refs.deleteModal.show()
            },
            async deleteOptionConfirm(){

                var vm = this

                if(vm.loadingOptionDelete) return

                if(!vm.optionToDetach) {
                    throw new Error('Option to delete not set')
                }

                vm.loadingOptionDelete = true
                const response = await ApiUtils.makePost(`anamnesis/option/detach`, {
                    anamnesis_option_id: vm.optionToDetach.id,
                    schedule_event_id: vm.eventId,
                })
                vm.loadingOptionDelete = false

                if(!response.ok){
                    const json = await response.json()
                    vm.showSnackBar(json.message || 'Ha ocurrido un error intentando eliminar la opcion')
                    return
                }

                const json = await response.json()

               vm.$emit('detach:option', {
                   id: vm.optionToDetach.id
                })

                vm.optionToDetach = null
                vm.$refs.deleteOptionModal.hide()
            },
            async deleteItemConfirm(){
                var vm = this

                if(vm.loadingDelete || !vm.currentProvider) return

                if(!vm.symptomToDetach) {
                    throw new Error('Item to delete not set')
                }

                vm.loadingDelete = true
                const response = await ApiUtils.makePost(`providers/${vm.currentProvider.id}/symptom/detach`, {
                    symptom_id: vm.symptomToDetach.pivot.symptom_id,
                    schedule_event_id: vm.eventId,
                })
                vm.loadingDelete = false

                if(!response.ok){
                    const json = await response.json()
                    vm.showSnackBar(json.message || 'Ha ocurrido un error intentando eliminar el item')
                    return
                }

               vm.$emit('detach:symptom', {
                   id: vm.symptomToDetach.pivot.symptom_id
               })

                vm.symptomToDetach = null
                vm.$refs.deleteModal.hide()
            },
            onSymptomAttach(symptom){
                var vm = this
                vm.$emit('attach:symptom', JSON.parse(JSON.stringify(symptom)))
            },
            resetAttach(){
                var vm = this
                vm.symptomToAttach = {
                    schedule_event_id: vm.eventId,
                    symptom_id: null,
                    eye: 'left',
                    duration: 0,
                    duration_unit: 'day'
                }
            },
            getDurationUnit(val){
                var vm =this
                const found = vm.durationUnits.find(unit => unit.value === val)
                return found ? found.text : '-'
            },
            onSymptomSelect(symptom){
                var vm = this
                var newSymptom = JSON.parse(JSON.stringify(symptom))
                newSymptom.symptom_id = symptom && symptom.id || null
                vm.$refs.symptomForm.show(newSymptom)
                vm.$refs.symptomPicker.clearSearch()

            },
            debounceSave: debounce(function(){
                this.save()
            },3000),
            async save(){
                var vm = this

                if(vm.loadingSave || !vm.commentChanged) return

                vm.errorMessages = ''
                vm.loadingSave = true
                const response = await ApiUtils.makePatch(`history/anamnesis/comment/${vm.eventId}`, null, {
                    comment: vm.comment
                })
                vm.loadingSave = false

                if(!response.ok){
                    const json = await response.json()
                    vm.errorMessages = json.message || 'Ha ocurrido un error intentando actualizar los datos'
                    return
                }

                const json = await response.json()
                vm.commentChanged = false
                vm.updatedAt = json.result.anamnesis.updated_at
                vm.$emit('update:comment', json.result.anamnesis.comment)

            },
            setTimeData(){
                var vm = this
                clearInterval(vm.timeInterval)
                vm.timeInterval = setInterval(function(){

                    if(!vm.updatedAt){
                        vm.time = '-'
                        return
                    }

                    const diff = vm.$moment().diff(vm.$moment(vm.updatedAt))
                    const duration = vm.$moment.duration(diff)

                    if(duration.hours() === 0 && duration.minutes() === 0){
                        var humanized = 'unos segundos'
                    }else{

                        var hoursForHumans = duration.hours() > 0 ? `${duration.hours()} hora${duration.hours() > 1 ? 's' : ''}` : ''
                        var minutesForHumans =  duration.minutes() > 0 ? `${duration.minutes()} minuto${duration.minutes() > 1 ? 's' : ''}` : ''

                        if(hoursForHumans && minutesForHumans){
                            var humanized =  `${hoursForHumans} y ${minutesForHumans}`
                        }else{
                            var humanized = hoursForHumans ? `${hoursForHumans}` : `${minutesForHumans}`
                        }

                    }

                    vm.time = `hace ${humanized}`

                }, 1000)
            }
        },
        watch: {
            updatedAt(val){
                this.setTimeData()
            },
            anamnesis(val){

                var vm = this
                vm.symptoms = val && val.symptoms || []
                vm.setTimeData()

            },
            comment(val){
                this.debounceSave()
                this.commentChanged = true
            },
            eventId(val){
                this.symptomToAttach.schedule_event_id = val
            }
        }
    }
</script>

<style scoped>
    >>>.v-list__tile.v-list__tile--link.v-list__tile--avatar.theme--light{
        height: 40px
    }
</style>
